import { render } from "./LoginByEmailButton.vue?vue&type=template&id=f420d1f6&scoped=true"
import script from "./LoginByEmailButton.vue?vue&type=script&lang=js"
export * from "./LoginByEmailButton.vue?vue&type=script&lang=js"

import "./LoginByEmailButton.vue?vue&type=style&index=0&id=f420d1f6&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f420d1f6"]])

export default __exports__